const getDisabledOption = (callType) => ({
  label: "Disable Recording",
  value: "disabled",
  meta: {
    description: `Recording, transcription, and AI Summary will not be available for any ${callType} calls.`,
  },
});

export const INBOUND_RECORDING_OPTIONS = [
  {
    label: "Record Automatically",
    value: "automatic",
    meta: {
      description: "Recording will automatically start when a contact answers the phone.",
    },
  },
  getDisabledOption("inbound"),
];

export const INBOUND_RECORDING_OPTIONS_ADJUSTED = [
  INBOUND_RECORDING_OPTIONS[0],
  getDisabledOption("inbound"),
];

export const OUTBOUND_RECORDING_OPTIONS = [
  INBOUND_RECORDING_OPTIONS[0],
  {
    label: "Record on Demand",
    value: "on_demand",
    meta: {
      description: "Recording will not start until the caller turns it on.",
    },
  },
  getDisabledOption("outbound"),
];

export const OUTBOUND_RECORDING_OPTIONS_ADJUSTED = [
  INBOUND_RECORDING_OPTIONS_ADJUSTED[0],
  OUTBOUND_RECORDING_OPTIONS[1],
  getDisabledOption("outbound"),
];

export const ADMIN_INBOUND_RECORDING_OPTIONS = [
  INBOUND_RECORDING_OPTIONS[0],
  {
    label: "Set Default by Brivity Number",
    value: "by_number",
    meta: {
      description: "Set recording defaults for each user with a Brivity number.",
    },
  },
  getDisabledOption("inbound"),
];

export const ADMIN_INBOUND_RECORDING_OPTIONS_ADJUSTED = [
  INBOUND_RECORDING_OPTIONS_ADJUSTED[0],
  ADMIN_INBOUND_RECORDING_OPTIONS[1],
  INBOUND_RECORDING_OPTIONS_ADJUSTED[1],
];

export const ADMIN_OUTBOUND_RECORDING_OPTIONS = [
  OUTBOUND_RECORDING_OPTIONS[1],
  OUTBOUND_RECORDING_OPTIONS[0],
  ADMIN_INBOUND_RECORDING_OPTIONS[1],
  OUTBOUND_RECORDING_OPTIONS[2],
];

export const ADMIN_OUTBOUND_RECORDING_OPTIONS_ADJUSTED = [
  OUTBOUND_RECORDING_OPTIONS_ADJUSTED[1],
  OUTBOUND_RECORDING_OPTIONS_ADJUSTED[0],
  ADMIN_INBOUND_RECORDING_OPTIONS_ADJUSTED[1],
  OUTBOUND_RECORDING_OPTIONS_ADJUSTED[2],
];
